import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../../../../RoomContext';
// import { useIntl } from 'react-intl';
import { useIntl } from 'react-intl';
import { permissions } from '../../../../permissions';
import { makePermissionSelector } from '../../../../store/selectors';
import 'draft-js/dist/Draft.css';
import * as toolareaActions from '../../../../store/actions/toolareaActions';
import * as privateChatActions from '../../../../store/actions/privateChatActions';

import './styles.css';
import EmojiPicker, { EmojiStyle } from 'emoji-picker-react';
import { ToastContainer, toast } from 'react-toastify';
import * as fileActions from '../../../../store/actions/fileActions';
import { Grid, LinearProgress, TextField } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';

const styles = (theme) => ({
	input :
	{
		display        : 'flex',
		flex           : 1,
		'&[type=file]' : {
			display : 'none'
		},
		// padding         : '8px',
		lineHeight      : '20px',
		fontSize        : '16px',
		width           : '100%',
		height          : '100%',
		overflowWrap    : 'break-word',
		borderRadius    : '4px',
		backgroundColor : '#ffffff'
		// overflow        : 'scroll'

	},
	icon : {
		padding : theme.spacing(1)
	}
});

const ChatInput = (props) =>
{
	const {
		isPrivateMessage,
		roomClient,
		displayName,
		peerId,
		picture,
		canChat,
		canShare,
		classes,
		browser,
		canShareFiles,
		chat,
		files,
		toolAreaOpen,
		templateIsFileShare,
		templateSendFiles,
		hasInputFileShare,
		templateChatMsgs,
		isModerator,
		hostControlSendChat,
		hostControlPrivateChat,
		hostControlSendFiles,
		addFile,
		isMobile,
		addPrivateMessage,
		currentParticipant
	} = props;

	const intl = useIntl();
	const [ message, setMessage ] = useState('');
	const [ showEmojis, setShowEmojis ] = useState(false);
	const [ loader, setLoader ] = useState(false);
	const inputRef = useRef();
	const emojiRef = useRef();

	const Clickout = (eve) =>
	{
		if (emojiRef.current?.contains(eve.target))
		{
			return;
		}
		setShowEmojis(false);
	};

	useEffect(() =>
	{
		document.addEventListener('mousedown', Clickout);

		return () =>
		{
			document.removeEventListener('mousedown', Clickout);
		};
	}, []);

	const sendMessage = () =>
	{
		if (message.trim() !== '' && message.trim().length <= 4000)
		{
			if (isPrivateMessage===true)
			{
				roomClient.sendPrivateMessage({
					toId    : currentParticipant?.id,
					message : {
						type    : 'message',
						time    : Date.now(),
						sender  : 'response',
						isRead  : null,
						name    : displayName,
						peerId  : peerId,
						picture : picture,
						text    : message?.replace(/</g, '&lt;').replace(/>/g, '&gt;')
					},
					displayName : currentParticipant?.displayName ? currentParticipant?.displayName : '',
					picture     : currentParticipant?.picture ? currentParticipant?.picture : ''

				});
			}
			else
			{
				roomClient.sendChatMessage({
					type    : 'message',
					time    : Date.now(),
					sender  : 'response',
					isRead  : null,
					name    : displayName,
					peerId  : peerId,
					picture : picture,
					text    : message?.replace(/</g, '&lt;').replace(/>/g, '&gt;')
				});

			}

		}
		inputRef.current.focus();
		setMessage('');
		setShowEmojis(false);
		// inputRef.current.focus();
	};

	const attachFile = async (e) =>
	{
		if (e.target.files.length > 0)
		{
			await props.roomClient.shareFiles({
				type       : 'file',
				time       : Date.now(),
				sender     : 'response',
				isRead     : null,
				name       : displayName,
				peerId     : peerId,
				picture    : picture,
				attachment : e.target.files
			});
		}
	};

	const getFileType = (fileName) =>
	{
		const extension = fileName?.split('.').pop();

		switch (extension)
		{
			case 'pdf':
				return 'pdf';
			case 'xlsx':
				return 'xlsx';
			case 'xls':
				return 'xls';
			case 'docx':
				return 'docx';
			case 'doc':
				return 'doc';
			case 'pptx':
				return 'pptx';
			case 'ppt':
				return 'ppt';
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
				return 'image';
			case 'mp3':
			case 'wav':
				return 'audio';
			case 'mp4':
			// case 'mov':
			// case 'mkv':
			// case '3gp':
			// case 'webm':
				return 'video';
			case 'txt':
			case 'csv':
				return 'text';
			default:
				return null;
		}
	};

	const handleAttachFile = async (e) =>
	{
		setLoader(true);
		// attachFile(e);
		const file = e?.target?.files[0];

		const filType=getFileType(file?.name);

		if (filType)
		{
			if (file?.size <= 50 * 1024 *1024)
			{
				try
				{
					// const formData = new FormData();

					// formData.append('file', file);

					await roomClient.uploadFileToS3(file, filType==='image'?'public/chatHistory/images':'public/chatHistory/files').then(async (res) =>
					{
						const uploadDoc={
							type      : 'file',
							fileType  : filType,
							time      : Date.now(),
							sender    : 'sending',
							url       : res.url,
							key       : res.key,
							fileName  : file.name,
							size      : file.size,
							isRead    : null,
							name      : displayName,
							peerId    : peerId,
							picture   : picture,
							meetingId : roomClient._roomTemplate.meetingDetails.meetingId
						};

						if (isPrivateMessage)
						{
							addPrivateMessage(
								{
									toId        : currentParticipant?.id,
									message     : { ...uploadDoc, isRead: true },
									displayName : currentParticipant?.displayName,
									picture     : currentParticipant?.picture
								});
							roomClient._sendPrivateFile({ toId: currentParticipant?.id, file: uploadDoc });
						}
						else
						{
							// addFile({ ...uploadDoc, isRead: true });
							roomClient._sendFile({ ...uploadDoc, upload: true });
							// const body = {
							// 	userId    : peerId,
							// 	meetingId : roomClient._roomTemplate.meetingDetails.meetingId,
							// 	sendTime  : Date.now(),
							// 	userName  : displayName,
							// 	type      : 'file',
							// 	fileType  : filType,
							// 	picture   : picture,
							// 	url       : res.url,
							// 	key       : res.key || res?.key,
							// 	fileName  : file.name
							// };

							// await roomClient.postInVcMainChat(body);
						}

						toast.success(intl.formatMessage({ id: 'File_uploaded_successfully', defaultMessage: 'File uploaded successfully' }), {
							position : toast.POSITION.TOP_RIGHT
						});

						e.target.value = null;

						setLoader(false);
					})
						.catch((err) =>
						{
							setLoader(false);
							toast.error(intl.formatMessage({ id: 'something_went_wrong', defaultMessage: 'Something went wrong.' }), {
								position : toast.POSITION.TOP_RIGHT
							});

						});

				}
				catch (error)
				{
					console.error('Error uploading file to S3:', error);
					toast.error(intl.formatMessage({ id: 'Error_sending_file', defaultMessage: 'Error sending file...' }), {
						position : toast.POSITION.TOP_RIGHT
					});
					setLoader(false);

				}
			}
			else
			{
				toast.error(intl.formatMessage({ id: 'File_size_exceeds_50MB_limit', defaultMessage: 'File size exceeds 50MB limit' }));
				setLoader(false);
			}

		}
		else
		{
			toast.error(intl.formatMessage({ id: 'Unsupported_file_format', defaultMessage: 'Unsupported file format' }));
			setLoader(false);
		}

	};

	const handleChatEmojis = (
		emojiData,
		e,
		fontName = 'Twemoji Country Flags',
		fontUrl = 'https://cdn.jsdelivr.net/npm/country-flag-emoji-polyfill@0.1/dist/TwemojiCountryFlags.woff2'
	) =>
	{
		e.stopPropagation();

		const style = document.createElement('style');

		style.textContent = `@font-face {
			  font-family: "${fontName}";
			  unicode-range: U+1F1E6-1F1FF, U+1F3F4, U+E0062-E0063, U+E0065, U+E0067,
		 		U+E006C, U+E006E, U+E0073-E0074, U+E0077, U+E007F;
			  src: url('${fontUrl}') format('woff2');
			  font-display: swap;
			}`;
		document.head.appendChild(style);

		setMessage((prevState) => (prevState + emojiData?.emoji));
		inputRef.current.focus();
	};

	const preview = {
		showPreview : false
	};
	const handleEmojisEnter = (e) =>
	{
		if (e.key === 'Enter')
		{
			setShowEmojis(false);
			sendMessage();
		}
	};

	const customEmoji = {
		activeSkinTone : 'neutral',
		emoji          : '🫠',
		names          : [ 'custom_emoji' ],
		unified        : '1fae0',
		// You may need to provide an image URL if the picker requires it
		getImageUrl    : () =>
		{
		// Replace 'custom_emoji_image_url' with the actual image URL for the emoji
			return 'custom_emoji_image_url';
		}
		// Add any other required properties
	};
	const handleMessage = (e) =>
	{
		if (e.target.value.trim().length<=4000)
		{
			setMessage(e.target.value);
		}
		else
		{
			toast.dismiss();
			toast.error(intl.formatMessage({ id: 'message_length_exceeds', defaultMessage: 'Message length exceeds the maximum limit of 4000 characters.' }));
		}

	};
	const handleEnter = (e) =>
	{
		if (e.key === 'Enter' && !e.shiftKey && message.trim() !== '')
		{
			e.preventDefault();
			sendMessage();
		}
	};

	const handleKeyPress = (e) =>
	{
		if (e.key === 'Enter')
		{
			e.preventDefault();
		}
	};

	useEffect(() =>
	{
		if (!isModerator && ((!hostControlSendChat && !isPrivateMessage) || (!hostControlPrivateChat && isPrivateMessage)))
		{
			message.trim() && setMessage('');
			showEmojis && setShowEmojis(false);
		}
	}, [ hostControlSendChat, isModerator, isPrivateMessage, hostControlPrivateChat ]);

	return (
		<div className='flexCol pdngXS'>
			{loader && (<LinearProgress />)}

			{!isModerator && ((!hostControlSendChat && !isPrivateMessage) || (!hostControlPrivateChat && isPrivateMessage)) ?
				<Grid className={classes.pdng} item container direction='column' justifyContent='center' alignItems='center'>Chat input is disabled by host</Grid>
				:
				// <div className='flexRow alignEnd brdrTop'>
			// 	<div className='pdngXXS emojiIconCntnr'>
			// 		<div className='emojiCntnr' ref={emojiRef} onKeyPress={handleEmojisEnter}>
			// 			{showEmojis &&
			// eslint-disable-next-line max-len
			// 				<EmojiPicker emojiStyle='google' className='emojiPopup' lazyLoadEmojis onEmojiClick={handleChatEmojis}
			// 					previewConfig={preview}
			// 				/>
			// 			}
			// 		</div>
			// 		<div className='icons'>
			// 			<Tooltip
			// 				title={intl.formatMessage({
			// 					id: 'label.emoji',
			// 					defaultMessage: 'Emoji'
			// 				})}
			// 				placement='top'
			// 				enterDelay='700'
			// 				enterNextDelay='700'
			// 			>
			// 				<Button
			// 					size='small'
			// 					classes={{ sizeSmall: classes.icon }}
			// 					className={`emojiIcon ${showEmojis ? 'show' : 'hide'}`}
			// 					aria-label={intl.formatMessage({
			// 						id: 'label.emoji',
			// 						defaultMessage: 'Emoji'
			// 					})}
			// 					onClick={() => setShowEmojis(true)}
			// 				>
			// 					<SentimentSatisfiedOutlinedIcon />
			// 				</Button>
			// 			</Tooltip>
			// 		</div>
			// 	</div>
			// 	<div className='flexMinWidthRow positionRel pdngXXS'>
			// 		<TextField
			// 			ref={inputRef}
			// 			value={message}
			// 			autoFocus
			// 			id='message'
			// 			variant='outlined'
			// 			fullWidth
			// 			size='small'
			// 			// placeholder='Message...'
			// 			placeholder={intl.formatMessage({
			// 				id: 'room.chatMessagePlaceHolder',
			// 				defaultMessage: 'Message...'
			// 			})}
			// 			onChange={handleMessage}
			// 			onKeyDown={handleEnter}
			// 		/>
			// 	</div>
			// 	<div className='flexAutoRow iconsCntnr pdngXXS'>
			// 		<div className='icons'>
			// 			{roomClient?._roomTemplate?.data?.fileSharing &&
			// 				<>
			// 					{isModerator ?
			// 						<React.Fragment>
			// 							<input
			// 								id='contained-button-file'
			// 								className="file_input"
			// 								disabled={!canShare || !hasInputFileShare}
			// 								type='file'
			// 								multiple
			// 								onChange={handleAttachFile}
			// 							/>
			// 							<label htmlFor='contained-button-file'>
			// 								<Tooltip
			// 									title={intl.formatMessage({
			// 										id: 'label.shareFile',
			// 										defaultMessage: 'Share file'
			// 									})}
			// 									placement='top'
			// 									enterDelay='700'
			// 									enterNextDelay='700'
			// 								>

			// 									<IconButton
			// 										size='small'
			// 										classes={{ sizeSmall: classes.icon }}
			// 										// color='primary'
			// 										aria-label={intl.formatMessage({
			// 											id: 'label.shareFile',
			// 											defaultMessage: 'Share file'
			// 										})}
			// 										disabled={!canShareFiles || !canShare}
			// 										component='span'
			// 										// onClick={(e) => (e.target.value = null)}
			// 										onMouseDown={(e) => e.preventDefault()}
			// 									>
			// 										<AttachFileIcon
			// 											size='small'
			// 										/>
			// 									</IconButton>
			// 								</Tooltip>
			// 							</label>
			// 						</React.Fragment> :
			// 						hostControlSendFiles && <React.Fragment>
			// 							<input
			// 								id='contained-button-file'
			// 								className="file_input"
			// 								disabled={!canShare ||
			// 									(!hostControlSendFiles
			// 										&& !hasInputFileShare)}
			// 								type='file'
			// 								multiple
			// 								onChange={handleAttachFile}
			// 							/>
			// 							<label htmlFor='contained-button-file'>
			// 								<Tooltip
			// 									title={intl.formatMessage({
			// 										id: 'label.shareFile',
			// 										defaultMessage: 'Share file'
			// 									})}
			// 									placement='top'
			// 									enterDelay='700'
			// 									enterNextDelay='700'
			// 								>

			// 									<IconButton
			// 										size='small'
			// 										classes={{ sizeSmall: classes.icon }}
			// 										// color='primary'
			// 										aria-label={intl.formatMessage({
			// 											id: 'label.shareFile',
			// 											defaultMessage: 'Share file'
			// 										})}
			// 										disabled={!canShareFiles || !canShare}
			// 										component='span'
			// 										// onClick={(e) => (e.target.value = null)}
			// 										onMouseDown={(e) => e.preventDefault()}
			// 									>
			// 										<AttachFileIcon
			// 											size='small'
			// 										/>
			// 									</IconButton>
			// 								</Tooltip>
			// 							</label>
			// 						</React.Fragment>
			// 					}
			// 				</>}
			// 		</div>
			// 		<div className='icons'>
			// 				<Button
			// 					size='small'
			// 					classes={{ sizeSmall: classes.icon }}
			// 					color='primary'
			// 					aria-label={intl.formatMessage({
			// 						id: 'label.send',
			// 						defaultMessage: 'Send'
			// 					})}
			// 					// eslint-disable-next-line max-len
			// 					onClick={sendMessage}
			// 				>
			// 					<SendIcon />
			// 				</Button>
			// 		</div>

			// 	</div>
			// </div>
				<div className='flexRow InputCntnr aCntr'>
					{(roomClient?._roomTemplate?.data?.fileSharing && (hostControlSendFiles || isModerator))&&
					<div className='flexAutoCol pRel pdngXS '>
						{/* <label className='file_btn' htmlFor='contained-button-file'> */}
						<img className='pointer icons1' src='icons/add.svg' alt='icons' />
						{/* onClick={(e) => (e.target.value = null)}
							onMouseDown={(e) => e.preventDefault()} */}
						{/* </label> */}
						{isModerator ?
							<input
								id='contained-button-file'
								className='file_input'
								disabled={!canShare || (!hostControlSendFiles && !hasInputFileShare)}
								type='file'
								title=''
								value=''
								onChange={handleAttachFile}
								onClick={(event) =>
								{
									event.target.value = null;
								}}
							/>
							:
							hostControlSendFiles &&
							<input
								id='contained-button-file'
								className='file_input'
								disabled={!canShare || (!hostControlSendFiles && !hasInputFileShare)}
								type='file'
								title=''
								value=''
								onChange={handleAttachFile}
								onClick={(event) =>
								{
									event.target.value = null;
								}}
							/>
						}
					</div>
					}
					<div className='flexMinWidthRow'>
						<TextField className='chatInput pdngHSM' rowsMax={3} fullWidth ref={inputRef} value={message} placeholder={intl.formatMessage({ id: 'type_Something', defaultMessage: 'Type Something' })} autoFocus id='message-container' onChange={handleMessage} onKeyDown={handleEnter} multiline/>
					</div>
					{
						!isMobile &&
						<div className='flexAutoCol pdngXS emojiIconCntnr' >
							<div className='flexAutoCol emojiCntnr' ref={emojiRef} onKeyPress={handleEmojisEnter}>
								{showEmojis &&
								<EmojiPicker emojiVersion={4.0} native emojiStyle={EmojiStyle.GOOGLE} className='emojiPopup' lazyLoadEmojis onEmojiClick={handleChatEmojis} previewConfig={preview} />							}
							</div>
							{showEmojis ?
								<CloseIcon
									onClick={() => setShowEmojis(false)}
									fontSize='medium'
									className='pointer icons1'
								/> :
								<img className='pointer icons1' src='icons/Icon.svg' alt='icons' onClick={() => setShowEmojis(true)} />
							}
						</div>
					}
					<div className='flexAutoCol pdngXS ' >
						<img className='pointer icons2' src='icons/send.svg' alt='icons' onClick={sendMessage} />
					</div>

				</div>
			}
			<ToastContainer
				position='top-right'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable
				pauseOnHover
			/>
		</div>
	);
};

ChatInput.propTypes =
{
	roomClient             : PropTypes.object.isRequired,
	displayName            : PropTypes.string,
	peerId                 : PropTypes.string.isRequired,
	picture                : PropTypes.string,
	canChat                : PropTypes.bool.isRequired,
	canShare               : PropTypes.bool.isRequired,
	classes                : PropTypes.object.isRequired,
	browser                : PropTypes.object.isRequired,
	canShareFiles          : PropTypes.bool.isRequired,
	chat                   : PropTypes.isRequired,
	files                  : PropTypes.isRequired,
	toolAreaOpen           : PropTypes.bool.isRequired,
	templateIsFileShare    : PropTypes.bool,
	templateSendFiles      : PropTypes.bool,
	hasInputFileShare      : PropTypes.bool,
	templateChatMsgs       : PropTypes.bool,
	handleChatEmojis       : PropTypes.func.isRequired,
	emojiSelected          : PropTypes.any.isRequired,
	openChatEmoji          : PropTypes.bool.isRequired,
	selectedChatEmoji      : PropTypes.any.isRequired,
	addFile                : PropTypes.func.isRequired,
	isModerator            : PropTypes.bool,
	hostControlSendChat    : PropTypes.bool,
	hostControlPrivateChat : PropTypes.bool,
	hostControlSendFiles   : PropTypes.bool,
	isMobile               : PropTypes.bool,
	isPrivateMessage       : PropTypes.any,
	addPrivateMessage      : PropTypes.func.isRequired,
	currentParticipant     : PropTypes.object

};

const makeMapStateToProps = () =>
{
	const hasPermission = makePermissionSelector(permissions.SEND_CHAT);
	const filePermission = makePermissionSelector(permissions.SHARE_SCREEN);
	const hasModeratorPermission = makePermissionSelector(permissions.MODERATE_ROOM);

	const mapStateToProps = (state) =>
		({
			displayName            : state.settings.displayName,
			peerId                 : state.me.id,
			picture                : state.me.picture,
			canChat                : hasPermission(state),
			canShare               : hasPermission(state),
			hasInputFileShare      : filePermission(state),
			browser                : state.me.browser,
			canShareFiles          : state.me.canShareFiles,
			chat                   : state.chat,
			files                  : state.files,
			toolAreaOpen           : state.toolarea.toolAreaOpen,
			templateIsFileShare    : state.toolarea.toolAreaOpen,
			templateSendFiles      : state.toolarea.templateSendFiles,
			templateChatMsgs       : state.toolarea.templateChatMsgs,
			handleChatEmojis       : state.toolarea.handleChatEmojis,
			emojiSelected          : state.room.emojiSelected,
			openChatEmoji          : state.toolarea.openChatEmoji,
			selectedChatEmoji      : state.toolarea.selectedChatEmoji,
			isModerator            : hasModeratorPermission(state),
			hostControlSendChat    : state.toolarea.hostControlSendChat,
			hostControlPrivateChat : state.toolarea.hostControlPrivateChat,
			hostControlSendFiles   : state.toolarea.hostControlSendFiles,
			isMobile               : state.me.browser.platform === 'mobile'

		});

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
	handleChatEmojis : (handleChatEmojis) =>
		dispatch(toolareaActions.handleChatEmojis(handleChatEmojis)),
	addFile : (file) =>
		dispatch(fileActions.addFile(file)),
	addPrivateMessage : (fileObj) =>
		dispatch(privateChatActions.addPrivateMessage(fileObj))
});

export default withRoomContext(
	connect(
		makeMapStateToProps,
		mapDispatchToProps,
		null,
		{
			areStatesEqual : (next, prev) =>
			{
				return (
					prev.room === next.room &&
					prev.me.browser === next.me.browser &&
					prev.me.roles === next.me.roles &&
					prev.me.canShareFiles === next.me.canShareFiles &&
					prev.peers === next.peers &&
					prev.settings.displayName === next.settings.displayName &&
					prev.me.picture === next.me.picture &&
					prev.chat === next.chat &&
					prev.files === next.files &&
					prev.toolarea.toolAreaOpen === next.toolarea.toolAreaOpen &&
					prev.toolarea.templateIsFileShare === next.toolarea.templateIsFileShare &&
					prev.toolarea.templateSendFiles === next.toolarea.templateSendFiles &&
					prev.toolarea.templateChatMsgs === next.toolarea.templateChatMsgs &&
					prev.toolarea.handleChatEmojis === next.toolarea.handleChatEmojis &&
					prev.toolarea.handleChatEmojis === next.toolarea.handleChatEmojis &&
					prev.room.emojiSelected === next.room.emojiSelected &&
					prev.toolarea.openChatEmoji === next.toolarea.openChatEmoji &&
					prev.toolarea.selectedChatEmoji === next.toolarea.selectedChatEmoji &&
					prev.toolarea.hostControlSendChat === next.toolarea.hostControlSendChat &&
					prev.toolarea.hostControlPrivateChat===next.toolarea.hostControlPrivateChat &&
					prev.toolarea.hostControlSendFiles === next.toolarea.hostControlSendFiles
				);
			}
		}
	)(withStyles(styles)(ChatInput))
);
